export const GET_FIRE_SAFETY_CALCULATION = 'FIRE_SAFETY/get_fire_safety_calculation';
export const GET_FIRE_SAFETY_LIST = 'FIRE_SAFETY/get_fire_safety_list';
export const UPDATE_CALCULATION_FIRE_SAFETY = 'FIRE_SAFETY/update_calculation_fire_safety';
export const GET_FIRE_SAFETY_SETTINGS = 'FIRE_SAFETY/get_fire_safety_settings';
export const UPDATE_FIRE_SAFETY_SETTINGS = 'FIRE_SAFETY/update_fire_safety_settings';